// React
import React from 'react';
// component
import CustomHeadphonesButton from '../custom-headphones-button';
// Styles
import useStyles from './CustomOutlineHeadphonesButton.styles';

const CustomOutlineHeadphonesButton = ({ classes, onClick }) => {
  const componentClasses = useStyles();
  return (
    <CustomHeadphonesButton
      classes={{
        button: componentClasses.button,
        icon: componentClasses.icon,
      }}
      onClick={onClick}
    />
  );
};
CustomOutlineHeadphonesButton.defaultProps = {
  classes: {},
};
export default CustomOutlineHeadphonesButton;
